var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcDefaultProfileImage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 106,
    height: 105,
    viewBox: "0 0 106 105",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "225%",
    id: "svtw158yic"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE9AE5",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5961F9",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "-125%",
    x2: "50%",
    y2: "100%",
    id: "ajucbf5njd"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE9AE5",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5961F9",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "be2dmx6fha",
    cx: 50.094,
    cy: 50,
    rx: 50.094,
    ry: 50
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.958 2.88)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "ygn4j8cljb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#be2dmx6fha"
  })), /*#__PURE__*/React.createElement("ellipse", {
    stroke: "#5C88FF",
    strokeWidth: 2,
    cx: 50.094,
    cy: 50,
    rx: 51.094,
    ry: 51
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#ygn4j8cljb)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25 24.889c6.903 0 12.5-5.572 12.5-12.445C37.5 5.572 31.903 0 25 0c-6.904 0-12.5 5.572-12.5 12.444 0 6.873 5.596 12.445 12.5 12.445z",
    fill: "url(#svtw158yic)",
    transform: "translate(26.042 19.12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 46.667C0 51.82 4.197 56 9.375 56h31.25C45.803 56 50 51.821 50 46.667c0-5.155-4.688-15.556-25-15.556-20.313 0-25 10.4-25 15.556z",
    fill: "url(#ajucbf5njd)",
    transform: "translate(26.042 19.12)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDefaultProfileImage);
export default __webpack_public_path__ + "static/media/ic_default_profile_image.411cb2ae9f016a09e35050d53cc760bb.svg";
export { ForwardRef as ReactComponent };